<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.pickUpProduct')" />
      <div class="grey lighten-1 py-2 px-10 black--text rounded text-body-2">
        {{ $t('message.pickUpProduct') }}
      </div>
      <ArrangeDelivery :label="$t('label.pickUpDetails')" class="mt-8" />
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex justify-center">
        <v-btn color="primary--text" class="px-15 d-block rounded-pill text-capitalize" @click="submitRefund" :disabled="!isValid">
          {{ $t('button.submit') }}
        </v-btn>
      </v-container>
    </bottom-bar>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import ArrangeDelivery from '@/components/checkout/ArrangeDelivery.vue'

export default {
  name: 'ReturnPickup',
  components: { LayoutContent, SectionTitle, ArrangeDelivery },
  data: () => ({
    deliveryDate: '',
    deliveryTime: ''
  }),
  computed: {
    ...mapState('auth', ['currentDeliveryAddress']),
    ...mapState('order', ['itemsForCheckout', 'orderSummary', 'arrangeDelivery']),

    isValid() {
      return this.arrangeDelivery.date !== '' && this.arrangeDelivery.time !== '' && this.currentDeliveryAddress.id !== ''
    }
  },
  methods: {
    ...mapActions('order', ['refundOrder']),
    async submitRefund() {
      await this.refundOrder({ pickup_date: this.arrangeDelivery.date, pickup_time: this.arrangeDelivery.time, pickup_delivery_address_id: this.currentDeliveryAddress.id })
        .then((res) => {
          this.$toast.success(res.message)
          this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_DASHBOARD })
        })
        .catch(({ error_message }) => {
          if (error_message === 'The product is not allowed to return refund.') this.$toast.error(this.$t('error.productNotAllowedToReturnRefund'))
          else this.$toast.error(error_message)
        })
    }
  }
}
</script>
